const log = (msg) => {
  if (process.env.NODE_ENV === "development") {
  }
};

export default log;
